module.exports = __webpack_public_path__ + "media/otter.dcca9d54.mp3";